export default __webpack_public_path__ + "static/social-edb778f0a7b9dc45ab6b66880f5d7905.jpeg";